"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react-hooks/exhaustive-deps */
const react_1 = require("@xstate/react");
const react_2 = __importStar(require("react"));
const useWindowWidth_1 = __importDefault(require("../../../lib/useWindowWidth"));
const utils_1 = require("../../../lib/utils");
const useManageAppointmentContext_1 = require("../../hooks/useManageAppointmentContext");
const constants_1 = require("../../lib/constants");
const styles_1 = require("../../../components/LayoutFactory/styles");
const States_1 = require("../../lib/constants/States");
const messages_1 = __importDefault(require("../../lib/messages"));
const SearchProviderButton_1 = __importDefault(require("../../../AppointmentCancelWidget-v2/components/SearchProviderButton/SearchProviderButton"));
const Tracking_1 = require("../../lib/constants/Tracking");
const Events_1 = require("../../lib/constants/Events");
const Header_1 = __importDefault(require("../Header/Header"));
const Banners_1 = require("../../../components/Banners");
const configs_1 = require("../../lib/constants/configs");
const DesktopLayout_1 = __importDefault(require("../../../components/LayoutFactory/DesktopLayout"));
const FullscreenLoader_1 = require("../../../components/Util/FullscreenLoader");
const AnimationContainer_1 = require("../../../components/LayoutFactory/AnimationContainer");
const useLayoutAnimation_1 = require("../../../hooks/useLayoutAnimation");
const RescheduleFlowMobileLayout_1 = require("../../../components/LayoutFactory/RescheduleFlowMobileLayout");
const MemoizedProviderSidebar_1 = __importDefault(require("../../../components/Sidebar/MemoizedProviderSidebar"));
const ManageAppointmentLayout = ({ service, shouldRenderSearchProviderButton, renderChildren }) => {
    const [headerHeight, setHeaderHeight] = (0, react_2.useState)(0);
    const [state] = (0, react_1.useService)(service);
    const { context } = state;
    const { aboveMd } = (0, useWindowWidth_1.default)();
    const { track } = (0, useManageAppointmentContext_1.useManageAppointmentContext)();
    const phone = (context === null || context === void 0 ? void 0 : context.provider)
        ? (0, utils_1.getMainContactNumber)(context.provider)
        : null;
    // Using the useLayoutAnimation hook instead of the local implementation
    const { direction, isAnimating: bodyIsAnimating, onAnimationComplete, onAnimationStart, setBackDirection } = (0, useLayoutAnimation_1.useLayoutAnimation)();
    const getCurrentService = (service) => {
        if (service.state.matches(States_1.reschedule)) {
            return service.state.context.apptTimeMachine;
        }
        if (service.state.matches(States_1.rescheduleReason)) {
            return service.state.context.reasonMachine;
        }
        return service;
    };
    // Using MemoizedProviderSidebar component instead of local implementation
    const sidebar = context.provider ? (react_2.default.createElement(MemoizedProviderSidebar_1.default, { provider: context.provider, appointment: context.appointment, appointmentQuery: context.appointmentQuery, showAppointmentId: service.state.matches(constants_1.states.appointmentRescheduled), appointmentIdMessage: messages_1.default.appointmentId })) : null;
    const showHeader = service.state.matches(States_1.reschedule) ||
        service.state.matches(States_1.rescheduleReason);
    const getHeaderMessage = () => {
        if (aboveMd) {
            return messages_1.default.back;
        }
        if (service.state.matches(States_1.reschedule)) {
            return messages_1.default.headerDateAndTime;
        }
        if (service.state.matches(States_1.rescheduleReason)) {
            return messages_1.default.headerConfirmation;
        }
        return messages_1.default.back;
    };
    const renderSearchProviderButton = shouldRenderSearchProviderButton ? (react_2.default.createElement(styles_1.StyledContainer, { "data-testid": "search-provider-button" },
        react_2.default.createElement(SearchProviderButton_1.default, { service: service }))) : null;
    const measuredHeaderRef = (0, react_2.useCallback)((header) => {
        if (showHeader && header !== null) {
            setHeaderHeight(header.getBoundingClientRect().height);
        }
    }, [showHeader]);
    const goBack = () => {
        setBackDirection();
        track(Tracking_1.userEvents.GO_BACK);
        getCurrentService(service).send(Events_1.GO_BACK);
    };
    const headerMessage = getHeaderMessage();
    const header = showHeader && (react_2.default.createElement(Header_1.default, { goBack: goBack, headerMessage: headerMessage, isAboveMd: aboveMd, ref: measuredHeaderRef }));
    const banner = aboveMd ? null : (react_2.default.createElement(Banners_1.SchedulingHelpBanner, { className: "scheduling-help-banner", phone: phone, onPhoneNumberClick: () => {
            track(Tracking_1.userEvents.SCHEDULING_HELP_BANNER_PHONE_NUMBER_CLICKED);
        } }));
    // Check if the current state matches any of the error or appointment rescheduled states
    const isErrorOrRescheduled = configs_1.errorOrRescheduledStates.some((value) => getCurrentService(service).state.matches(value));
    if (aboveMd) {
        return (react_2.default.createElement(DesktopLayout_1.default, { sidebar: sidebar, header: header, footer: renderSearchProviderButton },
            context.reasonMachine && (react_2.default.createElement(FullscreenLoader_1.FullScreenLoader, { service: context.reasonMachine, activeState: constants_1.states.appointmentRescheduling })),
            react_2.default.createElement(AnimationContainer_1.AnimationContainer, { direction: direction.current, onAnimationComplete: onAnimationComplete, state: state.value.toString(), onAnimationStart: onAnimationStart }, renderChildren(headerHeight, bodyIsAnimating))));
    }
    return (react_2.default.createElement(react_2.default.Fragment, null,
        header,
        react_2.default.createElement(AnimationContainer_1.AnimationContainer, { direction: direction.current, onAnimationComplete: onAnimationComplete, state: state.value.toString(), onAnimationStart: onAnimationStart },
            react_2.default.createElement(RescheduleFlowMobileLayout_1.RescheduleFlowMobileLayout, { sidebar: sidebar, banner: banner, footer: renderSearchProviderButton, isErrorOrRescheduled: isErrorOrRescheduled },
                context.reasonMachine && (react_2.default.createElement(FullscreenLoader_1.FullScreenLoader, { service: context.reasonMachine, activeState: constants_1.states.appointmentRescheduling })),
                renderChildren(headerHeight, bodyIsAnimating)))));
};
exports.default = ManageAppointmentLayout;
//# sourceMappingURL=ManageAppointmentLayout.js.map